import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { LayoutAreaProps } from './types';

const useLayoutAreaStyles = makeStyles(() => {
  return createStyles({
    area: {
      gridColumn: (props: LayoutAreaProps) => `span ${props.area.columns}`,
      gridRow: (props: LayoutAreaProps) => `span ${props.area.rows}`,
      borderLeft: (props: LayoutAreaProps) =>
        props.layoutIconProps ? `none` : `1px solid rgba(92, 92, 92, 0.32)`,
      borderBottom: (props: LayoutAreaProps) =>
        props.layoutIconProps ? `none` : `1px solid rgba(92, 92, 92, 0.32)`,
      backgroundColor: (props: LayoutAreaProps) => (props.layoutIconProps ? '#000' : 'transparent'),
      position: 'relative',
      '&:hover': {
        backgroundColor: '#303030',
      },
    },
    selected: {
      backgroundColor: '#4D61AF !important',
    },
  });
});

export default useLayoutAreaStyles;
